import {useContext} from "react";
import {TranslateContext} from "../context/TranslateContext";

function Translate({children}) {

    const {translate} = useContext(TranslateContext);

    return ' ' + translate(children)

}

export default Translate;